module.exports = __webpack_public_path__ + "static/mir-aminy-3-314f2e7462fe59d6d7fbf2624f48ea48.jpg";